// The languages an agent can speak. Mirrors the list on the Create Agent page,
// which mirrors what ElevenLabs offers.
export const AGENT_LANGUAGES = [
    { code: "ar", label: "Arabic", native: "العربية" },
    { code: "bg", label: "Bulgarian", native: "Български" },
    { code: "zh", label: "Chinese", native: "中文" },
    { code: "hr", label: "Croatian", native: "Hrvatski" },
    { code: "cs", label: "Czech", native: "Čeština" },
    { code: "da", label: "Danish", native: "Dansk" },
    { code: "nl", label: "Dutch", native: "Nederlands" },
    { code: "en", label: "English", native: "English" },
    { code: "fil", label: "Filipino", native: "Filipino" },
    { code: "fi", label: "Finnish", native: "Suomi" },
    { code: "fr", label: "French", native: "Français" },
    { code: "de", label: "German", native: "Deutsch" },
    { code: "el", label: "Greek", native: "Ελληνικά" },
    { code: "hi", label: "Hindi", native: "हिन्दी" },
    { code: "hu", label: "Hungarian", native: "Magyar" },
    { code: "id", label: "Indonesian", native: "Bahasa Indonesia" },
    { code: "it", label: "Italian", native: "Italiano" },
    { code: "ja", label: "Japanese", native: "日本語" },
    { code: "ko", label: "Korean", native: "한국어" },
    { code: "ms", label: "Malay", native: "Bahasa Melayu" },
    { code: "no", label: "Norwegian", native: "Norsk" },
    { code: "pl", label: "Polish", native: "Polski" },
    { code: "pt", label: "Portuguese", native: "Português" },
    { code: "ro", label: "Romanian", native: "Română" },
    { code: "ru", label: "Russian", native: "Русский" },
    { code: "sk", label: "Slovak", native: "Slovenčina" },
    { code: "es", label: "Spanish", native: "Español" },
    { code: "sw", label: "Swahili", native: "Kiswahili" },
    { code: "sv", label: "Swedish", native: "Svenska" },
    { code: "ta", label: "Tamil", native: "தமிழ்" },
    { code: "tr", label: "Turkish", native: "Türkçe" },
    { code: "uk", label: "Ukrainian", native: "Українська" },
    { code: "vi", label: "Vietnamese", native: "Tiếng Việt" },
];

// Everyday first names a receptionist in each language would have, written the
// way the greeting writes them (own script, proper accents). Voice library
// names are whatever their creators typed ("Matthew", "Ozgur"), so the
// quick-start names agents from here instead. Japanese receptionists give
// their family name, so those are surnames.
export const AGENT_NAMES = {
    ar: { female: ["ليلى", "سارة", "نور"], male: ["أحمد", "عمر", "يوسف"] },
    bg: { female: ["Мария", "Елена", "Габриела"], male: ["Георги", "Иван", "Николай"] },
    zh: { female: ["小雅", "晓婷", "欣怡"], male: ["志强", "浩然", "子轩"] },
    hr: { female: ["Ana", "Marija", "Ivana"], male: ["Ivan", "Luka", "Marko"] },
    cs: { female: ["Tereza", "Lucie", "Kateřina"], male: ["Jakub", "Tomáš", "Martin"] },
    da: { female: ["Freja", "Ida", "Sofie"], male: ["Mads", "Lucas", "Frederik"] },
    nl: { female: ["Sanne", "Emma", "Lotte"], male: ["Daan", "Thijs", "Bram"] },
    en: { female: ["Emma", "Olivia", "Grace"], male: ["James", "Daniel", "Oliver"] },
    fil: { female: ["Maria", "Angela", "Kristine"], male: ["Juan", "Miguel", "Carlo"] },
    fi: { female: ["Aino", "Helmi", "Sofia"], male: ["Eino", "Juho", "Elias"] },
    fr: { female: ["Juliette", "Camille", "Léa"], male: ["Thomas", "Lucas", "Hugo"] },
    de: { female: ["Anna", "Lena", "Sophie"], male: ["Lukas", "Jonas", "Felix"] },
    el: { female: ["Μαρία", "Ελένη", "Σοφία"], male: ["Γιώργος", "Νίκος", "Δημήτρης"] },
    hi: { female: ["प्रिया", "अनन्या", "नेहा"], male: ["आरव", "राहुल", "अर्जुन"] },
    hu: { female: ["Anna", "Zsófia", "Réka"], male: ["Bence", "Máté", "Dávid"] },
    id: { female: ["Putri", "Ayu", "Dewi"], male: ["Budi", "Rizky", "Adi"] },
    it: { female: ["Giulia", "Sofia", "Chiara"], male: ["Marco", "Luca", "Matteo"] },
    ja: { female: ["佐藤", "田中", "鈴木"], male: ["高橋", "伊藤", "渡辺"] },
    ko: { female: ["지연", "서연", "민지"], male: ["민준", "지훈", "현우"] },
    ms: { female: ["Nur", "Aisyah", "Siti"], male: ["Ahmad", "Amir", "Hafiz"] },
    no: { female: ["Nora", "Ingrid", "Emma"], male: ["Jakob", "Emil", "Lars"] },
    pl: { female: ["Anna", "Zuzanna", "Maja"], male: ["Jakub", "Piotr", "Kacper"] },
    pt: { female: ["Ana", "Beatriz", "Mariana"], male: ["João", "Pedro", "Tiago"] },
    ro: { female: ["Ioana", "Maria", "Elena"], male: ["Andrei", "Mihai", "Alexandru"] },
    ru: { female: ["Анна", "Мария", "Екатерина"], male: ["Иван", "Дмитрий", "Алексей"] },
    sk: { female: ["Zuzana", "Lucia", "Katarína"], male: ["Peter", "Martin", "Tomáš"] },
    es: { female: ["Lucía", "Sofía", "María"], male: ["Pablo", "Javier", "Diego"] },
    sw: { female: ["Amani", "Neema", "Zawadi"], male: ["Baraka", "Juma", "Jabari"] },
    sv: { female: ["Elsa", "Maja", "Alva"], male: ["William", "Erik", "Oscar"] },
    ta: { female: ["பிரியா", "கவிதா", "மீனா"], male: ["அருண்", "கார்த்திக்", "விஜய்"] },
    tr: { female: ["Elif", "Zeynep", "İlke"], male: ["Emre", "Özgür", "Mert"] },
    uk: { female: ["Олена", "Ірина", "Софія"], male: ["Андрій", "Олександр", "Тарас"] },
    vi: { female: ["Linh", "Lan", "Mai"], male: ["Minh", "Nam", "Huy"] },
};

/**
 * Gives each voice a different native name matching its gender, e.g. Turkish
 * female → Elif, male → Emre. Voices labelled neither take whichever name is free.
 */
export const assignAgentNames = (languageCode, voices = []) => {
    const names = AGENT_NAMES[languageCode] || AGENT_NAMES.en;
    const used = new Set();
    const takeFrom = (list) => {
        const name = list.find((candidate) => !used.has(candidate));
        if (name) used.add(name);
        return name;
    };

    return voices.map((voice) => {
        const gender = (voice.gender || "").toLowerCase();
        const preferred = gender === "male" ? names.male : names.female;
        const other = gender === "male" ? names.female : names.male;
        return { ...voice, agentName: takeFrom(preferred) || takeFrom(other) || "Alex" };
    });
};

// Browser codes that differ from the agent codes above.
const BROWSER_ALIASES = { tl: "fil", nb: "no", nn: "no" };

/** The first of the browser's preferred languages that an agent can speak, else English. */
export const getBrowserAgentLanguage = () => {
    const preferred = navigator.languages?.length ? navigator.languages : [navigator.language];
    for (const tag of preferred) {
        const base = (tag || "").toLowerCase().split("-")[0];
        const code = BROWSER_ALIASES[base] || base;
        if (AGENT_LANGUAGES.some((language) => language.code === code)) return code;
    }
    return "en";
};

export const getAgentLanguageLabel = (code) =>
    AGENT_LANGUAGES.find((language) => language.code === code)?.label || code;
